import type { ServerConfig } from '@ms-cloudpack/common-types';
import type { ReusedOptions } from '../../../types/ReusedOptions.js';

export interface StartOptions
  extends
    Pick<ReusedOptions, 'app' | 'cache' | 'login' | 'logBundleInfo' | 'logResolveMap' | 'mode'>,
    Pick<ServerConfig, 'showOverlay'> {
  /**
   * Whether to open the browser or a specific url to open the browser to.
   * Defaults to the value from `ServerConfig.open` or `true`.
   */
  open?: boolean | string;

  /** Mostly for testing: custom port for the API server */
  apiServerPort?: number | number[];

  /** Mostly for testing: custom port for the app server (also set in config via `server.port`) */
  appServerPort?: number | number[];

  /** Mostly for testing: custom port for the bundle server */
  bundleServerPort?: number | number[];
}
